<template>
  <div>
    <Form ref="searchForm" inline class="search-form">
      <Form-item>
        <Input
          style="width:200px"
          search
          placeholder="请输入班级名称"
          @on-search="search(1)"
          v-model="searchCondition.class_name"
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item>
        <Input
          style="width:200px"
          search
          placeholder="请输入讲师名称"
          @on-search="search(1)"
          v-model="searchCondition.teacher_name"
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item>
        <Input
          style="width:200px"
          search
          placeholder="请输入助教名称"
          @on-search="search(1)"
          v-model="searchCondition.assistant_name"
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/classGrade"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        :selectType="selectType"
        keyField="id"
        :selectedItems="selectedItems"
        keepSelected
        :autoLoadData="autoLoadData"
      >
        <template slot="footer-left">
          <Button
            icon="ios-refresh"
            class="btn-margin-right"
            type="text"
            @click="search(1)"
            style="margin-left:5px;"
          >刷新</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "ClassSelect",
  data() {
    return {
      columns: [
        { title: "班级名称", key: "class_name", minWidth: 180 },
        { title: "讲师名称", key: "teacher_name", minWidth: 120 },
        { title: "助教名称", key: "assistant_name", minWidth: 120 },
        { title: "班级人数", key: "student_number", minWidth: 100 }
      ],
      selectList: [],
      searchCondition: {
        class_name: "",
        teacher_name: "",
        course_name: "",
        assistant_name: ""
      }
    };
  },
  props: {
    selectedItems: {
      type: Array
    },
    selectType: {
      type: String,
      default: "single"
    },
    course_name: {
      type: String,
      default: ""
    },
    autoLoadData: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    rowsFormatter() {
      // rows.forEach(i => {});
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.real_name = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = [...val];
    },
    getSelectList() {
      return this.selectList;
    },
    recoverSelectedItems(selectedItems) {
      this.$refs.grid.recoverSelectedItems(selectedItems);
    },
    refresh() {
      this.$refs.grid.refresh();
    }
  },
  watch: {
    course_name() {
      this.searchCondition.course_name = this.course_name;
      this.search(1);
    }
  }
};
</script>
<style lang="scss">
.avatar {
  max-width: 64px;
}
</style>